import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { fetchChartData } from '../../services/api';
import {
  Line,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { getFormatter, getTranslatedLabel } from '../StatsFormatters';

const getThemeColor = variable => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

const ShipmentChart = ({
  timeFrame,
  startDate,
  endDate,
  BlueBarDataKey = null,
  GreenBarDataKey = null,
  lineDataKey = 'sales',
  height = 400,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const colorPrimary = getThemeColor('--color-primary');
  const colorAccent = getThemeColor('--color-accent');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formattedStartDate = startDate ? format(startDate, 'yyyy-MM-dd') : null;
        const formattedEndDate = endDate ? format(endDate, 'yyyy-MM-dd') : null;
        const fetchedData = await fetchChartData(formattedStartDate, formattedEndDate, timeFrame);
        setData(fetchedData);
      } catch (error) {
        setError('Erreur lors de la récupération des données graphiques');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate, timeFrame]);

  if (loading) return <p>Chargement...</p>;
  if (error) return <p>{error}</p>;

  const leftAxisKey = BlueBarDataKey || GreenBarDataKey;

  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={'date'} tickFormatter={getFormatter(timeFrame)} />
        {leftAxisKey && <YAxis yAxisId="left" tickFormatter={getFormatter(leftAxisKey)} />}
        <YAxis yAxisId="right" orientation="right" tickFormatter={getFormatter(lineDataKey)} />
        <Tooltip
          formatter={(value, name) => {
            const formatter = getFormatter(name);
            return [formatter(value), getTranslatedLabel(name)];
          }}
        />
        <Legend formatter={value => getTranslatedLabel(value)} />
        {BlueBarDataKey && <Bar yAxisId="left" dataKey={BlueBarDataKey} fill={colorPrimary} />}
        {GreenBarDataKey && <Bar yAxisId="left" dataKey={GreenBarDataKey} fill={colorAccent} />}
        <Line yAxisId="right" type="monotone" dataKey={lineDataKey} stroke="grey" />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default ShipmentChart;
